"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CircleCheck, ArrowRight, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function MasterYourMoneyMasterYourLife() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="241162" id="the-silent-engine-of-digital-transformation" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="grid lg:grid-cols-2 min-h-[100svh]">
        
        {}
        <div className="bg-background flex flex-col justify-center px-6 py-24 lg:px-16 xl:px-24 relative z-10">
          <div ref={textRef} className={`transition-all duration-1000 transform ${isTextVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary/10 text-primary text-sm font-mono mb-8 border border-primary/20">
              <TrendingUp className="w-4 h-4" />
              <span className="font-mono">ESTABLISHED 2014</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-foreground tracking-tighter leading-[1.1] mb-6">
              THE SILENT ENGINE<br />
              <span className="text-primary bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">OF DIGITAL TRANSFORMATION</span>
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground font-serif mb-10 max-w-xl leading-relaxed">
              We architect resilient, cost-effective infrastructure that scales with your ambition. Precision technology and proven excellence for leading global enterprises.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-8 h-14 text-base font-default shadow-lg shadow-primary/20">
                <Link to="/ConnectPage">
                  Get an Audit <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="bg-transparent border-border text-foreground hover:bg-accent hover:text-accent-foreground rounded-md px-8 h-14 text-base font-default">
                <Link to="/ServicesPage">
                  Our Services
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="bg-muted/10 relative flex items-center justify-center px-6 py-24 lg:p-16">
          <div ref={imgRef} className={`relative w-full max-w-md lg:max-w-lg aspect-[4/5] lg:aspect-square transition-all duration-1000 delay-300 transform ${isImgVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1676583/img/it_infrastructure_precision.png" alt="High-performance server infrastructure and digital architecture" className="w-full h-full object-cover rounded-md shadow-2xl grayscale hover:grayscale-0 transition-all duration-700" />

            {}
            <div className="absolute -bottom-12 left-1/2 -translate-x-1/2 w-[90%] max-w-sm lg:hidden z-20">
              <SuccessCard />
            </div>
          </div>
        </div>

        {}
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-30 hidden lg:block w-80 transition-transform duration-500 hover:-translate-y-[52%]">
           <SuccessCard />
        </div>
        
      </div>
    </section>;
}
function SuccessCard() {
  return <Card className="shadow-2xl border border-border bg-card/80 backdrop-blur-xl rounded-md">
      <CardHeader className="pb-2 flex flex-row items-center gap-4">
        <div className="w-12 h-12 rounded-md bg-secondary/20 flex items-center justify-center shrink-0 border border-secondary/30">
          <CircleCheck className="w-6 h-6 text-secondary" />
        </div>
        <div>
          <CardTitle className="text-lg font-default font-bold text-foreground">System Optimized</CardTitle>
          <p className="text-xs text-muted-foreground font-mono uppercase tracking-widest">Infrastructure Audit</p>
        </div>
      </CardHeader>
      <CardContent>
        <div className="mt-2">
          <span className="text-3xl font-mono font-bold text-foreground">99.9%</span>
          <p className="text-sm text-secondary font-medium mt-1 flex items-center gap-1 font-mono">
            <TrendingUp className="w-4 h-4" /> Uptime Guaranteed
          </p>
        </div>
      </CardContent>
    </Card>;
}